<div class="question-ranking__container">
  <empathy-choices-form [allowOther]="false"></empathy-choices-form>
</div>
